import * as React from 'react';
import { connect } from 'react-redux';
import ExportService from '../../services/ExportService';
import SignalRService from '../../signalRController';
import * as AuthorizationStore from '../../store/Authorization';

class ExportPrices extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            progress: { message: "", impactPartnerId: ""},
            file: undefined
        };

        this.triggerExport = this.triggerExport.bind(this);
    }

    private emptyState() {
        return {
            progress: { message: "", impactPartnerId: "" },
            file: undefined,
        };
    }

    triggerExport = async () => {
        const currentPartner = AuthorizationStore.getImpactPartnerFromLocalStorage();
        if (currentPartner) {
            const progress = {
                message: "export prices triggered!", impactPartnerId: currentPartner.Id
            };
            
            this.setState({ progress: progress });
            await ExportService.rebuild({ impactPartnerId: currentPartner.Id });
        }
    }

    componentDidMount = () => {
        SignalRService.registerReceiveEvent("ExportPrices",
            (msg) => {
                var progressObject = JSON.parse(msg.Message);
                this.setState({ progress: progressObject });
            }
        );

        SignalRService.registerReceiveEvent("ExportPrices_DONE",
            (msg) => {
                const currentPartner = AuthorizationStore.getImpactPartnerFromLocalStorage();
                var fileObject = JSON.parse(msg.Message);

                if (currentPartner.Id === fileObject.impactPartnerId) {
                    this.setState({ file: fileObject });
                }
            }
        );
    }

    componentWillUnmount() {
        SignalRService.unRegisterReceiveEvent("ExportPrices");
        SignalRService.unRegisterReceiveEvent("ExportPrices_DONE");
    }

    public render() {
        const { progress, file } = this.state;
        return (
            <React.Fragment>
                <div className="container">
                    <div className="row">
                        {!file && <div className="col-sm-12 mt-4">
                            <button className="btn mr-1" onClick={this.triggerExport}>Export Prices</button> {progress.message}
                        </div>}
                        {file && file.fileName && <div className="col-sm-12 mt-4">
                            <a href={"/temp/" + file.fileName} target="_blank">Download {file.fileName}</a>
                        </div>}
                    </div>
                </div>
            </React.Fragment>
        );
    }
};

export default connect()(ExportPrices);
